/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './Contract.module.scss';
import styles2 from '../Ecs/EcsPortal.module.scss';
import { useAuth } from '../../contexts/auth';
import { CreateTicket, handleImpressionsTrack, sendToGenioPDG } from '../../api';
import ConnectivityChart from './ConnectivityChart';
import {
  andriodSource,
  clickTracker,
  getProjectId,
  getSourceValue,
  handleRedirection,
  hasJdMartVertical,
  iosSource,
} from '../../lib/common';

const TextAndButton = ({
  contractDetails,
  faqObj,
  setShowSpecialNumberCheckbox,
  setShowResp,
  selectedDefaultNumArr,
  setSelectedDefaultNumArr,
}) => {
  const { ratings, receiveSmsObj, callDetailsResp, hidePositionClarificationFaq } = contractDetails;
  const { faqKey, paramUrl } = faqObj;
  const projectId = getProjectId();
  const [authState] = useAuth();
  const { selectedBusiness, userDetails } = authState;
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const source = getSourceValue();
  const queryParams = new URLSearchParams(window.location.search);
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));

  const handleButtonClick = async (button) => {
    if (button?.trackerKey) {
      await clickTracker(`FAQ_${faqKey}_${button?.trackerKey}`, `contract_FAQ_${faqKey}`);
    }
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `click_${button?.id === 'ticketCreate' ? 'proceed' : button?.impressionKey}`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `click_${faqKey}`;
      const llTrdInside = `faq_${faqKey}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
    }
    if (button?.id === 'ticketCreate') {
      try {
        const params = {
          vertical: hasJdMartVertical() ? 'JD MART CORPORATE' : 'Listing',
          category: 'CS',
          ticket_creator: 'BUSINESS',
          nm:
            projectId === 'csportal'
              ? selectedBusiness?.compname || ''
              : selectedBusinessGenio?.contractPersonName || selectedBusinessGenio?.companyName || '',
          created_by: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
          mob: projectId === 'csportal' ? userDetails?.mobile || '' : selectedBusinessGenio?.mobile || '',
          issue_type: faqObj?.issue || '',
          issue_sub_type: faqObj?.subIssue || '',
          issue_comment: selectedDefaultNumArr?.join(',') || '',
          document: [],
          city:
            projectId === 'genio'
              ? selectedBusinessGenio?.city || ''
              : queryParams.get('city') || selectedBusiness?.data_city,
          oid: '',
          orderid: '',
          docid:
            projectId === 'genio'
              ? selectedBusinessGenio?.docId || ''
              : queryParams.get('pid') || selectedBusiness?.docid || '',
          src: projectId === 'genio' ? 'sales-genio' : 'business',
          src_typ:
            projectId === 'genio' ? (selectedBusinessGenio?.concern === 'client' ? 'client' : 'internal') : 'csportal',
          src_nm: projectId === 'csportal' ? userDetails?.fullName || '' : profile?.full_name || '',
          src_mob: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
          projectId: projectId === 'csportal' ? 1 : '',
          parentId: projectId === 'genio' ? selectedBusinessGenio?.parentId || '' : selectedBusiness?.parentid || '',
          compnm: projectId === 'genio' ? selectedBusinessGenio?.companyName || '' : selectedBusiness?.compname || '',
        };

        const res = await CreateTicket(params);
        if (res?.errorCode === 0) {
          setShowResp(res?.result?.msg || '');
        }
      } catch (err) {
        console.log('Err in specialnumberadd ticket creation', err);
      }
      setSelectedDefaultNumArr([]);
    } else if (button?.id === 'proceed') {
      setShowSpecialNumberCheckbox(true);
    } else if (button?.id === 'changeBudget' && !hidePositionClarificationFaq) {
      try {
        const paramsData = {
          parentid: selectedBusiness?.parentid || '',
          data_city: selectedBusiness?.data_city || '',
          companyname: selectedBusiness?.compname || '',
        };
        const res = await sendToGenioPDG(paramsData);
        if (res?.errorCode === 0) {
          setShowResp('Our excecutives will get in touch with you shortly');
        } else {
          setShowResp('Something went wrong');
        }
      } catch (e) {
        console.log(e);
      }
    } else if (button?.id === 'viewRatings') {
      if (andriodSource.includes(source) || iosSource.includes(source)) {
        window.open(button?.url);
      } else {
        window.location = button?.url;
      }
    } else {
      handleRedirection(source, button?.url || '');
    }
  };

  const specialNumFeatures = [
    'Virtual Number ensures business continuity by routing calls to up to 12 mapped numbers (mobile, landline, toll-free).',
    'Choose between: Parallel Dialing – all numbers ring together, Sequential Dialing – numbers ring one after the other.',
    'In case of missed calls:',
    'Get notified via SMS/email.',
    'Users can leave a voice message, which is then auto-converted to an AI summary shown on your Leads dashboard.',
    'A Call Back button is available to connect instantly.',
    'All VN call data  is visible in the JD App inbox or Leads Dashboard',
    'For detailed insights, request a call analysis report through Customer Support via CS ticket or email.',
  ];

  const specialNumBlockFeatures = [
    'Never miss a Call',
    'Parallel Dialing rings all your mapped numbers simultaneously.',
    'Sequential Dialing rings each number one after the other',
    ' If no one answers, a missed call alert is sent via SMS or email.',
    'Users can now leave a voice message when you are not available to pick the call, which is converted into an AI-generated summary',
    'The message and summary appear in your Leads Dashboard, with a Call Back button for quick follow-up.',
    'Track all call enquiries through the JD App inbox or Leads dashboard, and request detailed reports via CS ticket or email',
  ];

  const viewRatingsButtons = [
    {
      id: 'viewRatings',
      url: ratings?.viewRatingsUrl || '',
      text: 'View ratings',
      classNames: 'blue_whitefill_animate color007',
      trackerKey: 'view',
      impressionKey: 'viewratings',
    },
    {
      id: 'moreRatings',
      url: ratings?.moreRatingsUrl || '',
      text: 'Get more ratings',
      classNames: 'bluefill_animate colorFFF',
      trackerKey: 'get',
      impressionKey: 'getmoreratings',
    },
  ];

  const hasRatings = faqKey === 'viewratings' && ratings?.ratings > 0;

  if (!hasRatings) {
    viewRatingsButtons?.shift();
  }

  const updatedHeaders = {
    csportal: [
      'You have the following numbers/email ids on your contract. Click on the button below if you wish to make changes to them.',
      'No numbers or email ids were found in your contract. Click on the button below to check and update details.',
    ],
    genio: [
      'Client has below numbers/email IDs on contract.',
      'No numbers or email ids were found in your contract. Client can change the number/email by visting the Edit Listing page',
    ],
  };

  const faqTypeData = {
    viewratings: {
      header: hasRatings
        ? 'Here are your ratings and reviews till date'
        : 'You have not received any ratings or reviews for your business yet. Click on the button below and ask your customers to rate their experience.',
      buttons: projectId === 'genio' ? [] : viewRatingsButtons,
    },
    budget: {
      header:
        'You can view your campaign details at the top on this page. Click on the button below if you wish to change your budget',
      buttons: [
        {
          id: 'changeBudget',
          url: paramUrl || '',
          text: 'Change budget',
          classNames: 'bluefill_animate colorFFF',
          trackerKey: 'redirection',
          impressionKey: 'changebudget',
        },
      ],
    },
    specialnumberblock: {
      header: 'Benefits of special number',
      buttons: [
        {
          id: 'proceed',
          text: 'Proceed',
          classNames: 'bluefill_animate colorFFF',
          trackerKey: 'proceed',
          impressionKey: 'proceed',
        },
      ],
      features: specialNumBlockFeatures,
    },
    unregisteredsms: {
      header: receiveSmsObj?.mobileArr?.length > 0 ? updatedHeaders[projectId][0] : updatedHeaders[projectId][1],
      buttons: [
        {
          id: 'editDetails',
          url: paramUrl || '',
          text: 'Edit details',
          classNames: 'bluefill_animate colorFFF',
          trackerKey: 'edit',
          impressionKey: 'editdetails',
        },
      ],
    },
    specialnumberconnectivity: {
      header: projectId === 'csportal' ? 'Benefits of VN and suggestion to pick calls' : 'Benefits of special number',
      features: specialNumFeatures,
    },
    specialnumberadd: {
      header:
        receiveSmsObj?.mobileArr?.length > 0
          ? 'Mention your numbers to be added'
          : 'No numbers were found in your contract. Click on the button below to check and update details.',
    },
  };

  const specialNumberAddFaqButton = {
    id: 'ticketCreate',
    text: 'Proceed',
    trackerKey: 'proceed',
    classNames: 'bluefill_animate colorFFF',
    impressionKey: 'ticketCreate',
  };

  if (receiveSmsObj?.mobileArr?.length > 0) {
    faqTypeData.specialnumberadd.buttons = [specialNumberAddFaqButton];
  }

  function ratingsView() {
    return (
      <div className={`${styles.Accordion__RatingBox} mt-15`}>
        <div className={`${styles.Accordion__Rating} `}>
          <div className={`${styles.Accordion__OverRate} font16 fw600 colorFFF`}>{ratings?.ratings}</div>
          <div className={`${styles.Accordion__StarIcon} csicon ml-2`} />
        </div>
        <div className={`${styles.Accordion__Rattext} font14 fw500 color777 pl-10`}>
          {ratings?.count} {ratings?.count > 1 ? 'Reviews' : 'Review'}
        </div>
      </div>
    );
  }

  function specialNumberFeaturesView() {
    return (
      <>
        <ul className={`${styles2.Accordion__DotItems} mt-10`}>
          {faqTypeData?.[faqKey]?.features?.map((each, idx) => (
            <li key={idx} className={`${styles2.Accordion__DotItem}`}>
              <span className={`${styles2.Accordion__DotItem__Circle} mr-10`} />
              <span className={`${styles2.Accordion__DotItem__Text} font12 fw400 color111`}>{each}</span>
            </li>
          ))}
        </ul>
        {faqKey === 'specialnumberconnectivity' && <ConnectivityChart callDetailsData={callDetailsResp} />}
      </>
    );
  }

  function unregisteredSmsView() {
    return (
      <>
        {receiveSmsObj?.mobileArr?.length > 0 && (
          <>
            <div className="font12 fw600 color111 mt-10">Mobiles:</div>
            <ul className={`${styles.Accordion__Items} p-10`}>
              {receiveSmsObj?.mobileArr.map((each, i) => (
                <li key={i} className={`${styles.Accordion__Item}`}>
                  {each}
                </li>
              ))}
            </ul>
            {receiveSmsObj?.email && (
              <>
                <div className="font12 fw600 color111 mt-10">Emails:</div>
                <ul className={`${styles.Accordion__Items} p-10`}>
                  <li className={`${styles.Accordion__Item}`}>{receiveSmsObj?.email}</li>
                </ul>
              </>
            )}
            {projectId === 'genio' && (
              <div className="font12 fw500 color111 mt-10">
                Client can change the number/email by visting the Edit Listing page
              </div>
            )}
          </>
        )}
      </>
    );
  }

  const handleSetDefaultNum = (num, isChecked) => {
    if (isChecked) {
      setSelectedDefaultNumArr((prevState) => [...prevState, num]);
    } else {
      setSelectedDefaultNumArr((prevState) => prevState.filter((each) => each !== num));
    }
  };

  const specialNumAddButtonEnable = selectedDefaultNumArr?.length > 0;

  const handleAddNumberClick = async () => {
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `cta_addnumbers`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_contract`;
      const llTrdInside = `faq_${faqKey}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
    }
    handleRedirection(source, faqObj?.paramUrl || '');
  };

  function specialNumbersAddView() {
    return (
      <>
        {receiveSmsObj?.mobileArr?.length > 0 && (
          <>
            <ul className={`${styles.Accordion__Items} p-10`}>
              {receiveSmsObj?.mobileArr.map((each, i) => (
                <li key={i} className={`${styles.Accordion__Item} ${styles.Accordion__Numbers_List} mt-10`}>
                  <p style={{ padding: 0, margin: 0, width: '200px' }}>{each}</p>
                  <label htmlFor={`checked${i}`} className={` ${styles.Accordion__Checkbox__Lable}`}>
                    <input
                      onChange={(e) => handleSetDefaultNum(each, e.target.checked)}
                      type="checkbox"
                      name="sidcity_radio"
                      id={`checked${i}`}
                      checked={selectedDefaultNumArr?.includes(each)}
                    />
                    <span
                      style={{ paddingLeft: 0 }}
                      className={` ${styles.Accordion__Checkbox__Text} font12 fw400 color111 mt-2`}
                    >
                      Display in search
                    </span>
                  </label>
                </li>
              ))}
            </ul>
          </>
        )}
        <div className="mt-12">
          <a
            aria-label="add_number"
            tabIndex={0}
            role="button"
            onKeyDown={() => {}}
            onClick={handleAddNumberClick}
            className="font13 fw500 color007 pointer"
          >
            + Add Number
          </a>
        </div>
      </>
    );
  }

  const stylesObj = {
    backgroundColor: `${specialNumAddButtonEnable ? '#0076d7' : '#CCCCCC'}`,
    border: `1px solid ${!specialNumAddButtonEnable ? '#E0E0E0' : '#CCCCCC'}`,
    transitionProperty: 'background-color, background-image, border-color, box-shadow',
    transition: 'all 0.8s',
    color: `#FFFFFF`,
  };

  return (
    <>
      <div className="p-10">
        <div
          className={`font12 fw600 color111 ${
            (faqKey === 'budget' ||
              (projectId === 'csportal' && faqKey === 'viewratings') ||
              (projectId === 'genio' && faqKey === 'viewratings' && hasRatings)) &&
            'text_center'
          }`}
        >
          {projectId === 'genio' && faqKey === 'viewratings' && !hasRatings ? (
            <div
              className="font12 fw400 color777"
              id="payments-faqs-ans"
              dangerouslySetInnerHTML={{ __html: faqObj?.ans }}
            />
          ) : (
            faqTypeData?.[faqKey]?.header
          )}
        </div>
        {hasRatings && ratingsView()}
        {['specialnumberblock', 'specialnumberconnectivity'].includes(faqKey) && specialNumberFeaturesView()}
        {faqKey === 'unregisteredsms' && unregisteredSmsView()}
        {faqKey === 'specialnumberadd' && specialNumbersAddView()}
        {projectId === 'csportal' && faqTypeData?.[faqKey]?.buttons?.length > 0 && (
          <div
            className={`${styles.Accordion__TwoButton__Group} mt-20`}
            role="group"
            aria-label="Accordion__TwoButton__Group"
          >
            {faqTypeData?.[faqKey]?.buttons?.map((button, idx) => (
              <button
                onClick={() => handleButtonClick(button)}
                key={idx}
                type="button"
                className={`${styles.Accordion__TwoButton} ${button.classNames} font13 fw600`}
                disabled={(faqKey === 'specialnumberadd' && !specialNumAddButtonEnable) || false}
                style={faqKey === 'specialnumberadd' ? stylesObj : {}}
              >
                {button.text}
              </button>
            ))}
          </div>
        )}
      </div>
      {hasRatings && projectId === 'csportal' && (
        <div className="font12 fw500 color111 text_center">Tip: Respond to your reviews and grow your business</div>
      )}
    </>
  );
};

export default TextAndButton;

TextAndButton.propTypes = {
  contractDetails: PropTypes.object,
  faqObj: PropTypes.object,
  setShowSpecialNumberCheckbox: PropTypes.func,
  setShowResp: PropTypes.func,
  selectedDefaultNumArr: PropTypes.array,
  setSelectedDefaultNumArr: PropTypes.func,
};
